export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Download & Install',
      description: 'Get our VPN application on your device in seconds. Compatible with all major platforms including Windows, Mac, iOS, and Android.'
    },
    {
      number: '02',
      title: 'Choose Your Server',
      description: 'Select from our global network of high-speed servers. Pick the location that best suits your needs for optimal performance.'
    },
    {
      number: '03',
      title: 'Connect Securely',
      description: 'Click connect and enjoy instant protection. Your internet traffic is now encrypted and your identity is completely anonymous.'
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-5xl font-bold text-gray-900 leading-tight mb-6">
              Simple Three-Step<br />
              Connection Process
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed">
              Getting started with JURINE VPN is incredibly easy. Follow these simple steps and you'll be protected in minutes.
            </p>
          </div>
          
          <div className="space-y-6">
            {steps.map((step, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-6 shadow-lg border-l-4 border-teal-500 hover:shadow-xl transition-all duration-300"
              >
                <div className="flex gap-6">
                  <div className="flex-shrink-0">
                    <span className="text-4xl font-bold text-teal-500">
                      {step.number}
                    </span>
                  </div>
                  <div className="border-l-2 border-gray-200 pl-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
